import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import CreateCompanyLogin from "./CreateCompanyLogin";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { CSVLink } from "react-csv";
import CreateCompanyContact from "./CreateCompanyContact";
import BulkUploadDialog from "./BulkUploadDialog";
import { useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import AddCompany from "../Master/CreateCompany/AddCompany";
import AddBookingCode from "../Master/CreateBookingCode/AddBookingCode";
import DisabledImage from "../../Resources/Images/disable.png";
import ActiveImage from "../../Resources/Images/ActiveImage.png";

import {
  SearchIcon,
  DownloadIcon,
  NotInterestedIcon,
  DoneOutlineIcon,
  AddIcon,
} from "../../Resources/Icons/icons";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../UiComponents/Transition/Transition";
import { checkUserType } from "../../Shared/CommonConstant";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  Modal,
  Stack,
  Badge,
} from "@mui/material";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";

import {
  GetCompanyContact,
  GetCompany,
  GetBookingCode,
  GetSubBookingCode,
  GetCompanyLogin,
  UpdateCompanyLogin,
  GetUser,
  FilterCompanyLogin,
  FilterCompanyContact,
  GetLinkBookingCode,
} from "../../Service/_index";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import TabFilter from "../Tabs/Tabs";
import CustomButton from "../../UiComponents/CommonBUtton/ConfirmBox";
import CustomModal from "../../UiComponents/CustomModel/CustomModel";
import CustomCheckboxList from "../../UiComponents/CommonCheckBox/CommonCheckBox";
import Loader from "../../UiComponents/Loader/Loader";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  // Handle boolean values by converting to numbers
  let aValue = a[orderBy];
  let bValue = b[orderBy];

  // Check if we're comparing boolean or undefined values (for isAutoFill field)
  if (typeof aValue === 'boolean' || typeof bValue === 'boolean' ||
    (orderBy === 'isAutoFill' && (aValue === undefined || bValue === undefined))) {
    // Treat undefined as true (the default value in the model)
    aValue = aValue === undefined ? 1 : (aValue ? 1 : 0);
    bValue = bValue === undefined ? 1 : (bValue ? 1 : 0);
  }

  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const CompanyLoginHeadcells = [
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  // Changes by Arun
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code - Sub Booking Code",
  },
  {
    id: "userIdNumber",
    placeMent: true,
    disablePadding: false,
    label: "Login Id",
  },
  {
    id: "password",
    placeMent: true,
    disablePadding: false,
    label: "Password",
  },
  {
    id: "name",
    placeMent: true,
    disablePadding: false,
    label: "User Name",
  },
  // {
  //   id: "url",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Url",
  // },
  {
    id: "remarks",
    placeMent: false,
    disablePadding: false,
    label: "Remark",
  },
  {
    id: "isAutoFill",
    placeMent: false,
    disablePadding: false,
    label: "Auto Fill",
    type: "switch",
  },
];

const CompanyContactcells = [
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code - Sub Booking Code",
  },
  {
    id: "name",
    placeMent: true,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "mobileNumber",
    placeMent: true,
    disablePadding: false,
    label: "Mobile",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  {
    id: "Desigination",
    placeMent: true,
    disablePadding: false,
    label: "Designation",
  },
];

function CompanyLoginEnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, isAllow } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const Headcells = isAllow?.isUser
    ? CompanyLoginHeadcells.filter(
      (e) => e.label !== "Action" && e.id !== "bookingCode"
    )
    : isAllow?.isSubCode
      ? CompanyLoginHeadcells.filter((e) => e.label !== "User Name")
      : isAllow?.isBranchManager
        ? CompanyLoginHeadcells.filter((e) => e.label !== "Action")
        : CompanyLoginHeadcells;

  return (
    <TableHead>
      <TableRow>
        {Headcells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 400 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

CompanyLoginEnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function CompanyContactEnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {CompanyContactcells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

CompanyContactEnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};
const CompanyLogin = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rowsPerPageInActiveCLdata, setRowsPerPageInActiveCLdata] =
    React.useState(10);
  const [pageInActiveCompanyLogin, setPageInactiveCompanyLogin] = useState(0);
  const [rowsPerPageCompanyContact, setRowsPerPageCompanyContact] =
    useState(10);
  const [pageCompanyContact, setPageCompanyContact] = useState(0);
  const [selectedData, setSelectedData] = React.useState({});
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [openActiveConfirmBox, setOpenActiveConfirmBox] = useState(false);
  const [companyLogin, setCompanyLogin] = React.useState([]);
  const [inActiveCompanyLogin, setInActiveCompanyLogin] = React.useState([]);
  const [companyContact, setCompanyContact] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [tmpBookingCodeDetails, setTmpBookingCodeDetails] = useState([]); // Changes by Arun
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [activeBoolean, setActiveBoolean] = useState();
  const [showCompanyLoginTable, setShowCompanyLoginTable] = useState(true);
  const [showCompanyContactTable, setShowCompanyContactTable] = useState(false);
  const [showColumns, setShowColumns] = useState(false);
  const [showdisabledTable, setShowDisabledTable] = useState(false);
  const [selectedComapny, setSelectedCompany] = useState("");
  const [selectedUser, setSelecteduser] = useState("");
  const [selectedBookingCode, setSelectedBookingCode] = useState("");
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState("");
  const [selectedAutoFill, setSelectedAutoFill] = useState("");
  const [openCompanyDrawer, setOpenCompanyDrawer] = React.useState(false);
  const [createCompanyLoginDrawer, setCreateCompanyLoginDrawer] =
    useState(false);
  const [createCompanyContactDrawer, setCreateCompanyContactDrawer] =
    useState(false);
  const [isAllow, setIsAllow] = useState({});
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  // New States for ui update
  const [commonData, setCommonData] = useState([]);
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isEdit: true,
    isSearch: true,
    isViewURL: true,
    isSwitch: true,
  });
  const [headCells, setHeadCells] = useState(CompanyLoginHeadcells);
  const [searchText, setSearchText] = useState("");
  const [paginationReset, setPaginationReset] = useState(0); // New state for pagination reset
  const [pageView, setPageView] = useState(2);
  const [selectedTab, setSelectedTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(CompanyLoginHeadcells);
  const [openLoader, setOpenLoader] = useState(false);
  const [openBulkUploadDialog, setOpenBulkUploadDialog] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const FilterOption = [
    {
      label: "Login Id",
      type: "activeLogin",
      value: 1,
      visibility: isAllow?.isUser || isAllow.isBranchManager ? "none" : "block",
    },
    {
      label: "Company Contact",
      type: "compContact",
      value: 2,
      visibility: "block",
    },
    {
      label: "Disable",
      type: "inactiveLogin",
      value: 3,
      visibility: isAllow?.isUser || isAllow.isBranchManager ? "none" : "block",
    },
    {
      label: " My Login Ids",
      type: "myLoginIds",
      value: 4,
      visibility: isAllow?.isUser ? "block" : "none",
    },
    {
      label: " Other Login Ids",
      type: "otherLoginIds",
      value: 5,
      visibility: "none",
    },
    {
      label: "All Login Ids",
      type: "allLoginIds",
      value: 6,
      visibility:
        isAllow?.isBranchManager || isAllow?.isUser ? "block" : "none",
    },
    {
      label: " Admin Login Ids",
      type: "adminLoginIds",
      value: 7,
      visibility: isAllow?.isBranchManager ? "block" : "none",
    },
    {
      label: "User Login Ids",
      type: "userLoginIds",
      value: 8,
      visibility: isAllow?.isBranchManager ? "block" : "none",
    },
  ];

  const FilterCompanyFunction = (e) => {
    setPageView(e?.value);
    let data = e?.type;
    if (data === "activeLogin") {
      CompanyLoginIdTableFunction();
    } else if (data === "compContact") {
      CompanyContactTableFunction();
    } else if (data === "inactiveLogin") {
      DisabledTableFunction();
    } else if (data === "myLoginIds") {
      MyLoginIdFunction();
    } else if (data === "otherLoginIds") {
      OtherLoginIdFunction();
    } else if (data === "allLoginIds") {
      AllLoginIdFunction();
    } else if (data === "adminLoginIds") {
      AdminLoginIdFunction();
    } else if (data === "userLoginIds") {
      AllUserLoginIdFunction();
    }
    setPage(0);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    FilterCompanyFunction(selectedOption);
  };


  const FilteredData = useMemo(() => {
    const filtered = commonData.filter((el) => {
      const searchValue = searchText.toLowerCase();

      // Build search string based on current tab/table
      let combinedString = "";

      if (showCompanyContactTable) {
        // Company Contact table columns
        combinedString = `
        ${el?.companyId?.shortName || ""}
        ${el?.bookingCodeId?.bookingCode || ""}
        ${el?.subBookingCodeId?.subBookingCode || ""}
        ${el?.name || ""}
        // ${el?.email || ""}
        ${el?.mobileNumber || ""}
        ${el?.branch || ""}
        // ${el?.Desigination || ""}
      `.toLowerCase();
      } else {
        // Company Login table columns (for Login Id, Disabled, and other login tabs)
        combinedString = `
        ${el?.companyId?.shortName || ""}
        ${el?.branch || ""}
        ${el?.bookingCodeId?.bookingCode || ""}
        ${el?.subBookingCodeId?.subBookingCode || ""}
        ${el?.userIdNumber || ""}
        ${el?.password || ""}
        ${el?.userId?.name || ""}
        ${el?.remarks || ""}
      `.toLowerCase();
      }

      return combinedString.includes(searchValue);
    });

    // Apply sorting to filtered data
    const sorted = stableSort(filtered, getComparator(order, orderBy));

    return sorted;
  }, [commonData, searchText, order, orderBy, showCompanyContactTable]);

  const visibleRowsActiveCompanyLogin = React.useMemo(
    () =>
      stableSort(
        filter.fn(
          companyLogin?.map((e) => ({
            ...e,
            companyName: e.companyId?.shortName,
          }))
        ),
        getComparator(order, orderBy)
      )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, filter, companyLogin]
  );

  const visibleRowsInActiveCompanyLogin = React.useMemo(
    () =>
      stableSort(
        filter.fn(inActiveCompanyLogin),
        getComparator(order, orderBy)
      )?.slice(
        pageInActiveCompanyLogin * rowsPerPageInActiveCLdata,
        pageInActiveCompanyLogin * rowsPerPageInActiveCLdata +
        rowsPerPageInActiveCLdata
      ),
    [
      order,
      orderBy,
      pageInActiveCompanyLogin,
      rowsPerPageInActiveCLdata,
      filter,
      inActiveCompanyLogin,
    ]
  );
  const visibleRowsCompanyContact = React.useMemo(
    () =>
      stableSort(
        filter.fn(companyContact),
        getComparator(order, orderBy)
      )?.slice(
        pageCompanyContact * rowsPerPageCompanyContact,
        pageCompanyContact * rowsPerPageCompanyContact +
        rowsPerPageCompanyContact
      ),
    [
      order,
      orderBy,
      pageCompanyContact,
      rowsPerPageCompanyContact,
      filter,
      companyContact,
    ]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangePageCompanyContact = (event, newPage) => {
    setPageCompanyContact(newPage);
  };

  const handleChangePageInActiveCompanyLogin = (event, newPage) => {
    setPageInactiveCompanyLogin(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const buttonRef = useRef(null);
  const csvLinkRef = useRef(null);

  const handleChangeRowsPerPageInActiveCLdata = (event) => {
    setRowsPerPageInActiveCLdata(parseInt(event.target.value, 10));
    setPageInactiveCompanyLogin(0);
  };

  const handleChangeRowsPerPageCompanyContact = (event) => {
    setRowsPerPageCompanyContact(parseInt(event.target.value, 10));
    setPageCompanyContact(0);
  };
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - companyLogin.length) : 0;

  const GetCompanyLoginData = () => {
    setOpenLoader(true);
    setCommonData([]);
    return GetCompanyLogin().then((res) => {
      const filteredData = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              companyName: e.companyId?.shortName,
              bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
              name: e?.userId?.name,
            };
          }
        })
        .filter(Boolean);
      // setCompanyLogin(filteredData);
      setCommonData(filteredData);
      setOpenLoader(false);
    });
  };

  // added by gokul...
  // useEffect(() => {
  //   if (isAllow.isClient || isAllow.isOperator) {
  //     FilterCompanyLogin({
  //       userId: selectedUser,
  //       companyId: selectedComapny,
  //       bookingCodeId: selectedBookingCode,
  //       subBookingCodeId: selectedSubBookingCode,
  //     }).then((res) => {
  //       setCompanyLogin(res?.data);
  //     });
  //   }
  // }, [
  //   selectedUser,
  //   selectedComapny,
  //   selectedBookingCode,
  //   selectedSubBookingCode,
  // ]);

  const GetCompanyContactData = () => {
    setOpenLoader(true);
    setCommonData([]);
    return GetCompanyContact()
      .then((res) => {
        setCompanyContact(res?.data);
        setCommonData(res?.data);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const GetActiveCompanyLoginData = () => {
    GetCompanyLogin().then((res) => {
      setCompanyLogin(res?.data?.filter((item) => item.isEnabled === true));
    });
  };

  const GetInActiveCompanyLoginData = () => {
    setCommonData([]);
    return FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
    }).then((res) => {
      const modifiedData = res?.data?.map((e) => ({
        ...e,
        companyName: e.companyId?.shortName,
        bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
        name: e?.userId?.name,
      }));
      // setInActiveCompanyLogin(
      //   modifiedData.filter((item) => item.isEnabled === false)
      // );
      setCommonData(modifiedData.filter((item) => item.isEnabled === false));
    });
  };

  const [linkBookingCode, setLinkBookingCode] = useState([]);
  const GetLinkBookingCodeDetails = () => {
    GetBookingCode({ isAscending: false }).then((res) => {
      const modifiedBookingCode = res.data.map((e) => {
        return {
          ...e,
          label: e.bookingCode,
          value: e._id,
        };
      });
      const extraOption = {
        label: "Add BookingCode",
        value: 0,
      };
      setLinkBookingCode([extraOption, ...modifiedBookingCode]);
    });
  };

  // Changes by Arun
  const onHandleCompanyChange = (companyId) => {
    setPaginationReset((prev) => prev + 1);
    setSelectedCompany(companyId);

    if (companyId) {
      // Load booking codes when company is selected
      if (tmpBookingCodeDetails.length === 0) {
        // If tmpBookingCodeDetails is empty, fetch it first
        GetBookingCodeDetails().then(() => {
          // After fetching, filter will happen in the next render
        });
      } else {
        // Filter existing booking codes by selected company
        setBookingCodeDetails(
          tmpBookingCodeDetails.filter(
            (element) => element.companyId._id == companyId
          ) || []
        );
      }
    } else {
      // Clear booking codes and sub booking codes when company is cleared
      setBookingCodeDetails([]);
      setSelectedBookingCode(null);
      setSelectedSubBookingCode(null);
    }
  };

  // NEW comment
  // React.useEffect(() => {
  // if (isAllow.isClient || isAllow.isOperator) { //already commented
  // GetActiveCompanyLoginData(); // already commented
  // }
  // GetCompanyContactData(); //new comment
  // GetLinkBookingCodeDetails(); //new comment
  // }, []); //new comment

  const CreateCompanyLoginData = () => {
    setSelectedData({});
    setCreateCompanyLoginDrawer(true);
  };

  const CreateCompanyContactData = () => {
    setSelectedData({});
    setCreateCompanyContactDrawer(true);
  };



  const GetCompanyDetails = async () => {
    try {
      const res = await GetCompany({ isAscending: true });
      const modifiedCompany = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      // console.log(companyLogin);
      // const FilterTableReleted = companyLogin?.map(
      //   (e) => e?.companyId?.shortName
      // );
      // const FilteredCompanyDetails = modifiedCompany.filter((e) =>
      //   FilterTableReleted?.includes(e?.shortName)
      // );
      setCompanyDetails(modifiedCompany);
    } catch (error) {
      console.error(error);
    }
  };

  const GetBookingCodeDetails = async () => {
    try {
      // const res = await GetBookingCode({ isAscending: true });
      // const modifiedBookingCode = res.data.map((e) => {
      //   return {
      //     ...e,
      //     label: e.bookingCode,
      //     value: e._id,
      //   };
      // });

      // Changes by Arun
      const res = await GetLinkBookingCode();
      const modifiedBookingCode = res.data.map((e) => {
        return {
          ...e,
          label: e.bookingCodeId.bookingCode,
          value: e.bookingCodeId._id,
          _id: e.bookingCodeId._id,
        };
      });
      // console.log("modifiedBookingCode ", modifiedBookingCode);
      setTmpBookingCodeDetails(modifiedBookingCode);
    } catch (error) {
      console.error(error);
    }
  };

  // getSubBooking Code details added by gokul...
  const GetSubBookingCodeDetails = async () => {
    try {
      const res = await GetSubBookingCode({ isAscending: true });

      const modifiedSubBookingCode = res.data.map((e) => {
        return {
          ...e,
          label: e.subBookingCode,
          value: e._id,
        };
      });

      // const FilterTableRelated = companyLogin.map(
      //   (e) => e?.subBookingCodeId?.subBookingCode
      // );
      //changes by gokul...
      // If no booking code is selected, show empty list
      // Otherwise, filter by the selected booking code
      const FilterSubBookingCodeDetails = selectedBookingCode
        ? modifiedSubBookingCode.filter(
          (e) => e?.bookingCodeId === selectedBookingCode
        )
        : [];

      setSubBookingCodeDetails(FilterSubBookingCodeDetails);
    } catch (err) {
      console.log(err);
    }
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      const ModifiedUserDetails = res.data.map((e) => {
        return {
          ...e,
          label: e.name + " - " + e.mobileNumber + " - " + e.email,
          value: e._id,
        };
      });
      // const FilterTableReleted = companyLogin?.map((e) => e.userId.name);
      // const filteredUserDetails = ModifiedUserDetails.filter((e) =>
      //   FilterTableReleted?.includes(e.name)
      // );
      setUserDetails([
        { _id: "All", value: "All", label: "All" },
        { _id: "Admin", value: "Admin", label: "Admin" },
        ...ModifiedUserDetails,
      ]);
    });
  };

  useEffect(() => {
    //   // if (callCount < 3) {
    //     GetCompanyDetails();
    const isallowObj = checkUserType(UserType);
    if (!isallowObj.isUser) {
      GetCompanyLoginData();
    }
    //     GetUserDetails();
    //     // setCallCount(callCount + 1);
    //   // }
  }, []);

  // useEffect(()=>{
  //  GetCompanyLoginData();
  // },[selectedBookingCode,selectedSubBookingCode,selectedComapny])


  React.useEffect(() => {
    GetCompanyDetails();
    GetUserDetails();
    // Don't load booking codes initially - they will be loaded when company is selected
  }, []); // Run only once on mount, not when commonData changes

  // Initialize bookingCodeDetails when tmpBookingCodeDetails is populated or company selected
  React.useEffect(() => {
    if (tmpBookingCodeDetails.length > 0 && selectedComapny) {
      setBookingCodeDetails(
        tmpBookingCodeDetails.filter(
          (element) => element.companyId._id == selectedComapny
        ) || []
      );
    }
  }, [tmpBookingCodeDetails, selectedComapny]);

  // NEW comment
  useEffect(() => {
    //new comment
    GetSubBookingCodeDetails(); //new comment
  }, [selectedBookingCode]); //added by gokul...//new comment

  // Handler to clear sub booking code when booking code is cleared
  const handleBookingCodeChange = (value) => {
    setPaginationReset((prev) => prev + 1);
    setSelectedBookingCode(value);
    // If booking code is cleared, also clear sub booking code
    if (!value) {
      setSelectedSubBookingCode(null);
    }
  };

  const handleUserChange = (value) => {
    setPaginationReset((prev) => prev + 1);
    setSelecteduser(value);
  };

  const handleSubBookingCodeChange = (value) => {
    setPaginationReset((prev) => prev + 1);
    setSelectedSubBookingCode(value);
  };

  const handleAutoFillChange = (value) => {
    setPaginationReset((prev) => prev + 1);
    setSelectedAutoFill(value);
  };

  const EditCompanyLoginData = (row) => {
    setSelectedData(row);
    setCreateCompanyLoginDrawer(true);
  };

  const ActiveBranchData = (row, active) => {
    setOpenActiveConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };

  const ActiveFunction = () => {
    UpdateCompanyLogin(selectedData._id, { isEnabled: activeBoolean }).then(
      (res) => {
        // activeBoolean ? GetInActiveCompanyLoginData() : GetCompanyLoginData();
        // Changes by Arun (For when disable the record, filter not working)
        activeBoolean ? GetInActiveCompanyLoginData() : filterCompanyLogin();
      }
    );
    setOpenActiveConfirmBox(false);
  };

  /**
   * Handle Auto Fill toggle
   */
  const handleAutoFillToggle = (row) => {
    const newAutoFillStatus = !row.isAutoFill;
    setCommonData((prevData) =>
      prevData.map((item) =>
        item._id === row._id ? { ...item, isAutoFill: newAutoFillStatus } : item
      )
    );
    UpdateCompanyLogin(row._id, { isAutoFill: newAutoFillStatus }).then(
      (res) => {
      }
    ).catch((error) => {
      setCommonData((prevData) =>
        prevData.map((item) =>
          item._id === row._id ? { ...item, isAutoFill: !newAutoFillStatus } : item
        )
      );
    });
  };

  // Changes by Arun
  const filterCompanyLogin = () => {
    setCommonData([]);
    return FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
    }).then((res) => {
      // console.log(res?.data);
      const modifiedData = res?.data?.map((e) => ({
        ...e,
        companyName: e.companyId?.shortName,
        bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
        name: e?.userId?.name,
      }));
      // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
      setCommonData(modifiedData.filter((item) => item.isEnabled === true));
      setInActiveCompanyLogin(
        modifiedData?.filter((item) => item.isEnabled === false)
      );
    });
    setPage(0);
  };

  const CompanyLoginIdTableFunction = () => {
    setOpenLoader(true);
    setHeadCells(CompanyLoginHeadcells);
    setCommonData([]);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(true);
    setShowDisabledTable(false);
    FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
    })
      .then((res) => {
        const modifiedData = res?.data?.map((e) => ({
          ...e,
          companyName: e.companyId?.shortName,
          bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
          name: e?.userId?.name,
        }));
        // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
        setCommonData(modifiedData?.filter((item) => item.isEnabled === true));
      })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
  };
  const CompanyContactTableFunction = () => {
    setCommonData([]);
    setHeadCells(CompanyContactcells);
    setShowCompanyContactTable(true);
    setShowCompanyLoginTable(false);
    setShowDisabledTable(false);
    setPage(0);
  };

  const [disable, setDisable] = useState(true);

  const DisabledTableFunction = () => {
    setOpenLoader(true);
    setHeadCells(CompanyLoginHeadcells);
    setDisable(false);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(false);
    setShowDisabledTable(true);
    setPage(0);
    if (
      selectedUser ||
      selectedComapny ||
      selectedBookingCode ||
      selectedSubBookingCode
    ) {
      return filterCompanyLogin().finally(() => {
        setOpenLoader(false);
      });
    } else {
      return GetInActiveCompanyLoginData().finally(() => {
        setOpenLoader(false);
      });
    }
  };
  // console.log("Sub", selectedSubBookingCode);

  const LoginUserId = sessionStorage.getItem("UserId");
  const MyLoginIdFunction = () => {
    // console.log("Sub",selectedSubBookingCode);
    setOpenLoader(true);
    setCommonData([]);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(true);
    setShowDisabledTable(false);
    const promise = FilterCompanyLogin({
      userId: LoginUserId,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
      requestType: "USER_ID",
    })
      .then((res) => {
        const modifiedData = res?.data?.map((e) => ({
          ...e,
          companyName: e.companyId?.shortName,
          bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
          name: e?.userId?.name,
        }));
        // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
        setCommonData(modifiedData?.filter((item) => item.isEnabled === true));
      })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
    return promise;
  };

  const OtherLoginIdFunction = () => {
    setCommonData([]);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(true);
    setShowDisabledTable(false);
    FilterCompanyLogin({
      userId: LoginUserId,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
      requestType: "OTHER_ID",
    }).then((res) => {
      const modifiedData = res?.data?.map((e) => ({
        ...e,
        companyName: e.companyId?.shortName,
        bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
        name: e?.userId?.name,
      }));
      // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
      setCommonData(modifiedData?.filter((item) => item.isEnabled === true));
    });
    setPage(0);
  };

  const AllLoginIdFunction = () => {
    setOpenLoader(true);
    setCommonData([]);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(true);
    setShowDisabledTable(false);
    FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
      requestType: "ALL",
    })
      .then((res) => {
        const modifiedData = res?.data?.map((e) => ({
          ...e,
          companyName: e.companyId?.shortName,
          bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
          name: e?.userId?.name,
        }));
        // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
        setCommonData(modifiedData?.filter((item) => item.isEnabled === true));
      })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
  };

  const AdminLoginIdFunction = () => {
    setOpenLoader(true);
    setCommonData([]);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(true);
    setShowDisabledTable(false);
    FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
      requestType: "ADMIN",
    })
      .then((res) => {
        const modifiedData = res?.data?.map((e) => ({
          ...e,
          companyName: e.companyId?.shortName,
          bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
          name: e?.userId?.name,
        }));
        // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
        setCommonData(modifiedData?.filter((item) => item.isEnabled === true));
      })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
  };

  const AllUserLoginIdFunction = () => {
    setOpenLoader(true);
    setCommonData([]);
    setShowCompanyContactTable(false);
    setShowCompanyLoginTable(true);
    setShowDisabledTable(false);
    FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
      requestType: "ALL_USER_ID",
    })
      .then((res) => {
        const modifiedData = res?.data?.map((e) => ({
          ...e,
          companyName: e.companyId?.shortName,
          bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
          name: e?.userId?.name,
        }));
        // setCompanyLogin(modifiedData?.filter((item) => item.isEnabled === true));
        setCommonData(modifiedData?.filter((item) => item.isEnabled === true));
      })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
  };

  const headersOfComLogin = [
    // Changes by Arun (For table alignment)
    { label: "Company Name", key: "companyId.shortName" },
    { label: "Branch", key: "branch" },
    { label: "Booking Code", key: "bookingCodeId.bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCodeId.subBookingCode" },
    { label: "Login Id", key: "userIdNumber" },
    { label: "Password", key: "password" },
    { label: "UserName", key: "userId.name" },
    // { label: "Remarks", key: "remarks" },
    { label: "Url", key: "url" },
  ];
  const headersOfComContact = [
    { label: "Company Name", key: "companyId.shortName" },
    { label: "Booking Code", key: "bookingCodeId.bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCodeId.subBookingCode" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Mobile", key: "mobileNumber" },
    { label: "Branch", key: "branch" },
    { label: "Desigination", key: "Desigination" },
  ];
  const csvFile = {
    filename:
      showCompanyLoginTable || showdisabledTable
        ? "Company Login"
        : showCompanyContactTable
          ? "Company Contact"
          : "",
    headers:
      showCompanyLoginTable || showdisabledTable
        ? headersOfComLogin
        : showCompanyContactTable
          ? headersOfComContact
          : "",
    data:
      showCompanyLoginTable || showdisabledTable
        ? FilteredData
        : showCompanyContactTable
          ? commonData
          : "",
  };

  let tableTitle;
  if (showCompanyLoginTable) {
    tableTitle = "Company Login";
  } else if (showCompanyContactTable) {
    tableTitle = "Company Contact";
  } else {
    tableTitle = "Disabled Company Login";
  }

  // filterContact added dy gokul...
  const GetFilterCompanyContactData = () => {
    setOpenLoader(true);
    setCommonData([]);
    return FilterCompanyContact({
      // userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
    })
      .then((res) => {
        setCompanyContact(res?.data);
        setCommonData(res?.data);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const GetFilterCompanyLoginData = () => {
    setCommonData([]);
    FilterCompanyLogin({
      userId: selectedUser,
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      subBookingCodeId: selectedSubBookingCode,
      isAutoFill: selectedAutoFill,
    }).then((res) => {
      const filteredData = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              companyName: e?.companyId?.shortName,
              bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
              name: e?.userId?.name,
            };
          }
        })
        .filter(Boolean);
      // setCompanyLogin(filteredData);
      setCommonData(filteredData);
    });
  };

  // NEW Comment
  // useEffect(() => {//new comment
  //   GetFilterCompanyContactData();//new comment
  // }, [selectedComapny, selectedBookingCode, selectedSubBookingCode]); //new comment

  // New Comment All
  // useEffect(() => {
  //   const isallowObj = checkUserType(UserType);
  //   if (!isallowObj.isUser) {
  //     GetFilterCompanyLoginData();
  //   } else {
  //     MyLoginIdFunction();
  //   }
  // }, [
  //   selectedUser,
  //   selectedComapny,
  //   selectedBookingCode,
  //   selectedSubBookingCode,
  // ]);

  // New Comment All
  // useEffect(() => {
  //   const isallowObj = checkUserType(UserType);
  //   if (!isallowObj.isUser) {
  //     filterCompanyLogin();
  //   }
  // }, [
  //   selectedUser,
  //   selectedComapny,
  //   selectedBookingCode,
  //   selectedSubBookingCode,
  // ]);

  const UserType = sessionStorage.getItem("userType");
  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, [UserType]);

  const handleClearAllState = () => {
    setPage(0); // Reset to page 1 when filters are cleared
    setSelecteduser(null);
    onHandleCompanyChange(null);
    setSelectedBookingCode(null);
    setSelectedSubBookingCode(null);
    setSelectedAutoFill("");
    const isallowObj = checkUserType(UserType);
    if (!isallowObj.isUser) {
      // When clearing all filters, fetch all data without any filters
      if (selectedTab === 1) {
        GetCompanyLoginData();
      } else if (selectedTab === 3) {
        GetInActiveCompanyLoginData();
      }
    } else {
      MyLoginIdFunction();
    }
    // Fetch all company contact data without filters
    if (selectedTab === 2) {
      GetCompanyContactData();
    }
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    setPage(0); // Reset to page 1 when filters are applied
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      console.log(selectedTab, selectedUser, ".../...");
      if (selectedTab === 1) {
        const isallowObj = checkUserType(UserType);
        if (!isallowObj.isUser) {
          // Check if all filters are cleared - if so, show all data
          if (
            !selectedUser &&
            !selectedComapny &&
            !selectedBookingCode &&
            !selectedSubBookingCode &&
            !selectedAutoFill
          ) {
            GetCompanyLoginData();
          } else {
            GetFilterCompanyLoginData();
          }
        }
      }
      if (selectedTab === 4) {
        MyLoginIdFunction();
      }

      if (selectedTab === 2) {
        GetFilterCompanyContactData();
      }

      if (selectedTab === 3) {
        DisabledTableFunction();
      }
    }
  }, [searchTrigger]);

  const handleClearSingleFilter = (filterId) => {
    // Show loader
    setOpenLoader(true);
    setPaginationReset((prev) => prev + 1); // Reset page when filter is cleared

    // Calculate updated filter values based on which filter is being cleared
    const updatedUser = filterId === 1 ? null : selectedUser;
    const updatedCompany = filterId === 2 ? null : selectedComapny;
    const updatedBookingCode = filterId === 3 ? null : selectedBookingCode;
    const updatedSubBookingCode =
      filterId === 4 || filterId === 3 ? null : selectedSubBookingCode;

    // Clear the specific filter based on ID
    if (filterId === 1) {
      setSelecteduser(null);
    } else if (filterId === 2) {
      onHandleCompanyChange(null);
    } else if (filterId === 3) {
      setSelectedBookingCode(null);
      setSelectedSubBookingCode(null); // Also clear sub booking code
    } else if (filterId === 4) {
      setSelectedSubBookingCode(null);
    } else if (filterId === 5) {
      setSelectedAutoFill("");
    }

    // Refresh data immediately with calculated values (no need to wait for state update)
    if (selectedTab === 1) {
      const isallowObj = checkUserType(UserType);
      if (!isallowObj.isUser) {
        // Check if all filters are cleared - if so, show all data
        if (
          !updatedUser &&
          !updatedCompany &&
          !updatedBookingCode &&
          !updatedSubBookingCode &&
          (filterId === 5 ? true : !selectedAutoFill)
        ) {
          GetCompanyLoginData().finally(() => {
            setOpenLoader(false);
          });
        } else {
          FilterCompanyLogin({
            userId: updatedUser,
            companyId: updatedCompany,
            bookingCodeId: updatedBookingCode,
            subBookingCodeId: updatedSubBookingCode,
            isAutoFill: filterId === 5 ? "" : selectedAutoFill,
          })
            .then((res) => {
              const filteredData = res.data
                .map((e) => {
                  if (e.isEnabled) {
                    return {
                      ...e,
                      companyName: e?.companyId?.shortName,
                      bookingCode: `${e?.bookingCodeId?.bookingCode} - ${e?.subBookingCodeId?.subBookingCode}`,
                      name: e?.userId?.name,
                    };
                  }
                })
                .filter(Boolean);
              setCommonData(filteredData);
            })
            .finally(() => {
              setOpenLoader(false);
            });
        }
      }
    } else if (selectedTab === 4) {
      MyLoginIdFunction().finally(() => {
        setOpenLoader(false);
      });
    } else if (selectedTab === 2) {
      GetFilterCompanyContactData().finally(() => {
        setOpenLoader(false);
      });
    } else if (selectedTab === 3) {
      DisabledTableFunction().finally(() => {
        setOpenLoader(false);
      });
    }
  };

  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  // Memoize filterBoxData to prevent unnecessary recreations that trigger FilterBox updates
  // Only recreate when the actual filter values or dropdown data changes
  const filterBoxData = useMemo(
    () => [
      {
        id: 1,
        label: "Select User",
        data: userDetails,
        setState: handleUserChange,
        value: selectedUser,
        type: "input",
        variation: "single",
      },
      {
        id: 2,
        label: "Select Company",
        data: companyDetails,
        setState: onHandleCompanyChange,
        value: selectedComapny,
        type: "input",
        variation: "single",
      },
      {
        id: 3,
        label: "Select BookingCode",
        data: bookingCodeDetails,
        setState: handleBookingCodeChange,
        value: selectedBookingCode,
        type: "input",
        variation: "single",
      },
      {
        id: 4,
        label: "Select SubBookingCode",
        data: subBookingCodeDetails,
        setState: handleSubBookingCodeChange,
        value: selectedSubBookingCode,
        type: "input",
        variation: "single",
      },
      {
        id: 5,
        label: "Auto Fill",
        data: [
          { label: "Yes", value: "true", _id: "true" },
          { label: "No", value: "false", _id: "false" },
        ],
        setState: handleAutoFillChange,
        value: selectedAutoFill,
        type: "input",
        variation: "single",
      },
      // {
      //   id: 6,
      //   label: "Select Date",
      //   setDate: setDateRange,
      //   type: "date",
      // },
    ],
    [
      userDetails,
      companyDetails,
      bookingCodeDetails,
      subBookingCodeDetails,
      selectedUser,
      selectedComapny,
      selectedBookingCode,
      selectedSubBookingCode,
      selectedAutoFill,
    ]
  );

  const handleColumnToggle = (id) => {
    setHeadCells((prevColumns) =>
      prevColumns.some((col) => col.id === id)
        ? prevColumns.filter((col) => col.id !== id)
        : [...prevColumns, CompanyLoginHeadcells.find((col) => col.id === id)]
    );
    setSelectedColumns((prevColumns) =>
      prevColumns.some((col) => col.id === id)
        ? prevColumns.filter((col) => col.id !== id)
        : [...prevColumns, CompanyLoginHeadcells.find((col) => col.id === id)]
    );
  };

  const activeFiltersCount = [
    selectedUser,
    selectedComapny,
    selectedBookingCode,
    selectedSubBookingCode,
    selectedAutoFill,
  ].filter(Boolean).length;

  const handleExport = () => {
    setExportLoading(true);
    // Trigger the CSV download
    if (csvLinkRef.current) {
      csvLinkRef.current.link.click();
    }
    // Show loader for a brief moment while CSV is being generated
    setTimeout(() => {
      setExportLoading(false);
    }, 1000);
  };

  return (
    <>
      {/* NEW */}
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    {tableTitle}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{ color: "#344054" }}
                          />
                        }
                        disabled={exportLoading}
                        onClick={handleExport}
                      >
                        {exportLoading ? "Exporting..." : "Export"}
                      </Button>
                      {/* Hidden CSVLink triggered by ref */}
                      <CSVLink
                        ref={csvLinkRef}
                        style={{ display: "none" }}
                        {...csvFile}
                      />
                      {selectedTab === 1 && (
                        <Button
                          className="Master_Card_create_Button w-100"
                          onClick={() => setOpenBulkUploadDialog(true)}
                        >
                          XL Upload Jobs
                        </Button>
                      )}
                      {[1, 2].includes(selectedTab) && (
                        <Button
                          className="Master_Card_create_Button w-100"
                          startIcon={<AddIcon sx={{ marginRight: "1.5px" }} />}
                          onClick={() =>
                            selectedTab === 1
                              ? CreateCompanyLoginData()
                              : CreateCompanyContactData()
                          }
                        >
                          Create
                        </Button>
                      )}
                      {/* <IconButton
                        sx={{
                          border: "1px solid #D0D5DD",
                          borderRadius: "8px",
                          padding: "8px",
                        }}
                        onClick={() => setShowColumns(true)}
                      >
                        <ViewColumnOutlinedIcon />
                      </IconButton> */}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )
              }
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Insurance Company"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>

              <MasterCommonTable
                data={FilteredData}
                tableConfig={tableConfig}
                columns={headCells}
                handleEdit={EditCompanyLoginData}
                handleApprove={ActiveBranchData}
                handleAutoFillToggle={handleAutoFillToggle}
                tableTotalCount={FilteredData?.length || 0}
                loading={openLoader}
                paginationReset={paginationReset}
              />
            </Grid >
          </Box >
        </Box >
      </div >

      <CustomModal
        open={showColumns}
        onClose={() => setShowColumns(false)}
        title="Select Columns"
        anchorRef={buttonRef}
      >
        <CustomCheckboxList
          columns={CompanyLoginHeadcells}
          selectedColumns={selectedColumns}
          handleColumnToggle={handleColumnToggle}
        />
      </CustomModal>
      <Dialog
        open={createCompanyLoginDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "40%",
            },
          },
        }}
      >
        {createCompanyLoginDrawer ? (
          <CreateCompanyLogin
            setCreateCompanyLoginDrawer={setCreateCompanyLoginDrawer}
            GetActiveCompanyLoginData={CompanyLoginIdTableFunction}
            selectedData={selectedData}
            formType={selectedData._id ? "edit" : "add"}
            title={selectedData._id ? "Update" : "Create"}
          />
        ) : null}
      </Dialog>

      <Dialog
        open={createCompanyContactDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{ style: { maxWidth: "50%" } }}
      >
        {createCompanyContactDrawer ? (
          <CreateCompanyContact
            setCreateCompanyContactDrawer={setCreateCompanyContactDrawer}
            GetCompanyContactData={GetCompanyContactData}
            selectedData={selectedData}
            formType={selectedData._id ? "edit" : "add"}
            title={selectedData._id ? "Update" : "Create"}
          />
        ) : null}
      </Dialog>

      <ConfirmBox
        open={openActiveConfirmBox}
        title={selectedData.isEnabled ? "Disable" : "Active"}
        content={`Are you sure want to ${selectedData.isEnabled ? "Inactive" : "Active"
          }`}
        confirmButton={selectedData.isEnabled ? "Disable" : "Active"}
        setOpenConfirmBox={setOpenActiveConfirmBox}
        Function={ActiveFunction}
        icon={
          selectedData.isEnabled ? <NotInterestedIcon /> : <DoneOutlineIcon />
        }
        img={selectedData.isEnabled ? DisabledImage : ActiveImage}
        color={selectedData.isEnabled ? "error" : "success"}
      />
      {
        openCompanyDrawer ? (
          <Drawer
            open={openCompanyDrawer}
            sx={{ zIndex: 1000 }}
            anchor="right"
            PaperProps={{ sx: { width: { xs: "100%", sm: "25%" } } }}
          >
            <AddCompany
              title={"Create & Exit"}
              formType={"add"}
              setOpenCompanyDrawer={setOpenCompanyDrawer}
              GetActiveData={GetCompanyDetails}
            />
          </Drawer>
        ) : null
      }
      {/* <Loader open={openLoader} /> */}

      {/* Bulk Upload Dialog */}
      <BulkUploadDialog
        open={openBulkUploadDialog}
        onClose={() => setOpenBulkUploadDialog(false)}
      />
    </>
  );
};
export default CompanyLogin;
